import React, { useState } from 'react'
import NewElement from '../NewElement'
import CreateModal from '../CreateModal'
import RichCardMsgForm from './RichCardMsgForm'
import RichCardPreview from '../RichCardPreview'
import { RBM_ELEMENT_ERRORS_MESSAGES, RBM_ELEMENT_ERRORS } from '../constants'
import { Squares2X2Icon } from '@heroicons/react/24/outline'

const CarouselMsgForm = ({
  elementInfo = {},
  setInfo,
  isConversational,
  errors,
  replyOptions,
  emailFields = []
}) => {
  const [cards, setCards] = useState(elementInfo.cards || [])
  const [cardIndex, setCardIndex] = useState(null)
  const [newCardInfo, setNewCardInfo] = useState({})
  const [isNewCardOpen, setNewCardOpen] = useState(false)

  const handleCardSubmit = () => {
    if (cardIndex === null) {
      setCards([...cards, newCardInfo])
      setInfo({ ...elementInfo, cards: [...cards, newCardInfo] })
    } else {
      const newCards = [...cards]
      newCards[cardIndex] = newCardInfo
      setCards(newCards)
      setInfo({ ...elementInfo, cards: newCards })
      setCardIndex(null)
    }
    setNewCardOpen(false)
    setNewCardInfo({})
  }

  const deleteCard = (index) => {
    const newCards = [...cards]
    newCards.splice(index, 1)
    setCards(newCards)
    setInfo({ ...elementInfo, cards: newCards })
  }

  const getButtonText = () => (cardIndex === null ? 'Añadir Tarjeta' : 'Actualizar Tarjeta')

  const handleCancel = () => {
    setNewCardOpen(false)
    setCardIndex(null)
    setNewCardInfo({})
  }

  const onSetOpen = (isOpen) => {
    setNewCardOpen(isOpen)
    if (!isOpen) {
      setNewCardInfo({})
      setCardIndex(null)
    }
  }

  return (
    <div className="space-y-5">
      <CreateModal
        open={isNewCardOpen}
        setOpen={onSetOpen}
        isSmall={false}
        title={cardIndex === null ? 'Nueva Tarjeta' : 'Editar Tarjeta'}
      >
        <div>
          <RichCardMsgForm
            errors={errors}
            elementInfo={newCardInfo}
            setInfo={setNewCardInfo}
            setOpen={onSetOpen}
            isConversational={isConversational}
            replyOptions={replyOptions}
            emailFields={emailFields}
          />
          <div className="mt-5 pt-4 border-t border-gray-100 flex w-full justify-between">
            <button
              className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
              onClick={handleCancel}
            >
              Cancelar
            </button>
            <button
              className="px-5 py-2.5 bg-indigo-600 text-white text-sm font-medium rounded-lg hover:bg-indigo-700 transition-colors shadow-sm"
              onClick={handleCardSubmit}
            >
              {getButtonText()}
            </button>
          </div>
        </div>
      </CreateModal>

      <div>
        <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-3">
          <Squares2X2Icon className="h-4 w-4 text-gray-400" />
          Tarjetas del carrusel
        </label>
        <div className="flex gap-3 flex-wrap">
          {cards.map((card, index) => (
            <RichCardPreview
              onRemove={() => deleteCard(index)}
              card={card}
              key={index}
              onClick={() => {
                setCardIndex(index)
                setNewCardInfo(card)
                setNewCardOpen(true)
              }}
            />
          ))}
          {cards.length < 3 && (
            <NewElement isNewCard={true} action={() => setNewCardOpen(true)} />
          )}
        </div>
        {errors.includes(RBM_ELEMENT_ERRORS.MISSING_CARDS) && (
          <p className="text-red-500 text-xs mt-1.5">
            {RBM_ELEMENT_ERRORS_MESSAGES[RBM_ELEMENT_ERRORS.MISSING_CARDS]}
          </p>
        )}
      </div>
    </div>
  )
}

export default CarouselMsgForm
